<template>
    <section class="pi-card">
        <!-- Header -->
        <div class="pi-header">
            <i class="fal fa-info-circle text-blue-500"></i>
            <h2 class="text-lg leading-6 font-medium text-blue-500 mb-0">{{ $t('post.page.information.general') }}</h2>
        </div>

        <div class="pi-body">
            <!-- Title -->
            <div class="pi-field" v-if="post.title">
                <span class="pi-label">{{ $t('post.page.information.information') }}</span>
                <h3 class="pi-title">{{ post.title }}</h3>
            </div>

            <!-- Content (only if different from title) -->
            <div class="pi-field" v-if="post.content && stripHtml(post.content) !== post.title">
                <span class="pi-label">Description</span>
                <div class="pi-content">
                    <div class="pi-content-text" v-html="formatContent(post.content)"></div>
                    <i
                        type="button"
                        v-clipboard:copy="
                            post.content
                                .replace(/(<([^>]+)>)/gi, ' ')
                                .replace(/\&nbsp;/g, '')
                        "
                        class="fal fa-copy pi-copy"
                    ></i>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'PostInfo',
    props: ['post'],
    methods: {
        formatContent(message) {
            return unescape(message)
        },
        stripHtml(html) {
            if (!html) return ''
            const tmp = document.createElement('div')
            tmp.innerHTML = html
            return (tmp.textContent || tmp.innerText || '').trim()
        }
    }
}
</script>

<style scoped>
.pi-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.pi-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    border-bottom: 1px solid #f1f5f9;
}


.pi-body {
    padding: 20px 24px;
}

.pi-field {
    margin-bottom: 18px;
}

.pi-field:last-child {
    margin-bottom: 0;
}

.pi-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 6px;
}

.pi-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
    line-height: 1.4;
}

.pi-content {
    display: flex;
    align-items: flex-start;
    gap: 10px;
}

.pi-content-text {
    flex: 1;
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.7;
    word-break: break-word;
}

.pi-copy {
    color: #3b82f6;
    cursor: pointer;
    font-size: 0.85rem;
    flex-shrink: 0;
    margin-top: 3px;
    transition: color 0.15s;
}

.pi-copy:hover {
    color: #1d4ed8;
}

@media (max-width: 640px) {
    .pi-body {
        padding: 16px;
    }

    .pi-copy {
        display: none;
    }
}
</style>
